import styled from 'styled-components'

export const STable = styled.table`
    width: 100%;
    overflow: auto;
    table-layout: fixed;
`

export const SProperties = styled.div`
    display: grid;
    grid-column-gap: ${({ theme }) => theme.sizing.margin.xl};
    grid-row-gap: ${({ theme }) => theme.sizing.margin.l};
    margin-left: ${({ theme }) => theme.sizing.margin.m};
    font-size: 16px;
    grid-template-columns: 1fr 1fr;
    @media (max-width: 768px) {
        margin: 20px;
    }
`
export const SPropertiesValue = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`
export const SIconValue = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`

export const SLoadingProperty = styled.span`
    color: gray;
    text-transform: lowercase;
`

export const SButton = styled.button`
    height: 30px;
    border: 1px solid #006ef0;
    background-color: unset;
    padding: 4px 5px;
    border-radius: 25px;
    text-decoration: none;
    margin-left: 5px;
    font-size: 12px;
    color: #006ef0;
`

export const SLink = styled.button`
    color: ${({ theme }) => theme.font.linkColor};
    background: none;
    border: none;
    padding: 0;
    text-align: left;

    &:hover {
        color: ${({ theme }) => theme.brandColors.CA_Blue};
        text-decoration: underline;
    }
    &:active {
        color: ${({ theme }) => theme.font.darkestColor};
        text-decoration: none;
    }
`
